import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { CustomerService } from '../services/customer.service';
import { Customer } from '../models/customer.model';

export const customerByIdResolver: ResolveFn<Customer> = (route) => {
    return inject(CustomerService).getCustomerById(+route.paramMap.get('id'));
};
